"use client";

import { c as _c } from "react/compiler-runtime";
import RegLoginComponent from "@/app/components/auth";
import { useTranslations } from "next-intl";
import isMobileView from "@/app/utils/isMobileView";
import React from "react";
import Image from "next/image";
export default function AuthPage() {
  const $ = _c(2);
  const t = useTranslations();
  let t0;
  if ($[0] !== t) {
    t0 = <>{isMobileView ? <div className="custom-container mt-20"><RegLoginComponent /></div> : <div className="h-screen"><div className="grid h-full grid-cols-2 items-center gap-x-20"><div className="custom-container"><div className="w-[500px]"><RegLoginComponent /></div></div><div className="flex h-full flex-col items-center justify-center bg-charcoal-50"><div className="custom-container flex flex-col items-center"><p className="mb-2 text-center text-[28px] font-semibold text-charcoal-900">بدون خرید و فروش سود دریافت کنید!</p><p className="text-center text-lg text-charcoal-600">سودمکس؛ کسب درآمد منظم از دارایی دیجیتال.</p><Image width={400} height={349} src="/images/sood-max/auth-banner.png" alt={t("general.COMPANY_NAME")} /></div></div></div></div>}</>;
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}